import React from 'react'

import ChefPrimaryFields from './primary-fields'
import ChefContactInfo from './contact-info'
import ChefSocial from './social'
import ChefDetails from './details'

const AdminChefProfile = ({ chef }) => {
    return (
        <>
            <h2>Chef Profile</h2>
            <ChefPrimaryFields chef={chef} />
            <ChefSocial chef={chef} />
            <ChefContactInfo chef={chef} />
            <ChefDetails chef={chef} />
        </>
    )
}

export default AdminChefProfile
